import React, { useRef } from "react";
import { withRouter } from "react-router-dom";

import { DOMAIN } from "../config";

function API(props) {
  const iframeEl = useRef(null);

  return (
    <>
      <iframe
        title="docs"
        style={{
          display: "block"
        }}
        src={`//${DOMAIN}/docs/index.html${props.location.hash}`}
        // src={`/docs/index.html${props.location.hash}`}
        width="100%"
        height="100%"
        frameBorder="0"
        ref={iframeEl}
        onLoad={() => {
          let iframeWindow = iframeEl.current.contentWindow;
          const locationHashChanged = () => {
            let currentHash = iframeWindow.location.hash.substr(1);
            let state = { title: "", url: window.location.href };
            let newUrl = "/api#".concat(currentHash);
            window.history.replaceState(state, "", newUrl);
          };
          iframeWindow.window.addEventListener("hashchange", locationHashChanged, false);
        }}
      />
    </>
  );
}

export default withRouter(API);
